module.exports = __webpack_public_path__ + "img/studioalfa-logo.f6ceca35.jpg";